module.exports = __webpack_public_path__ + "media/svg-new/avatar-17 2-bcf9e53a.svg";